if (!customElements.get('filazoo-product-tabs')) {
  customElements.define(
    'filazoo-product-tabs',
    class FilazooProductTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[data-tab-button]'));
        this.panels = Array.from(this.querySelectorAll('[data-tab-panel]'));
        this.panelsContainer = this.querySelector('.filazoo-product-tabs__panels');
        this.activePanel = this.panels.find((panel) => !panel.hidden);

        this.style.setProperty('--product-tab-count', this.tabs.length);

        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.selectTab(index));
          tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
        });

        if (window.Shopify?.designMode) {
          this.addEventListener('shopify:block:select', (event) => {
            const selectedTab = event.target.matches('[data-tab-button]')
              ? event.target
              : event.target.querySelector('[data-tab-button]');

            let selectedIndex = this.tabs.indexOf(selectedTab);

            if (selectedIndex === -1) {
              const selectedPanel = event.target.closest('[data-tab-panel]');
              selectedIndex = this.panels.indexOf(selectedPanel);
            }

            if (selectedIndex !== -1) this.selectTab(selectedIndex);
          });
        }

        if (this.panelsContainer && this.activePanel) {
          this.syncPanelHeight(true);

          this.resizeObserver = new ResizeObserver(() => this.syncPanelHeight());
          this.panels.forEach((panel) => this.resizeObserver.observe(panel));

          requestAnimationFrame(() => {
            this.panelsContainer.classList.add('is-height-ready');
          });
        }
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
      }

      selectTab(index, moveFocus = false) {
        const selectedTab = this.tabs[index];
        const selectedPanel = this.panels[index];
        if (!selectedTab || !selectedPanel) return;

        const currentHeight = this.panelsContainer?.getBoundingClientRect().height;
        if (currentHeight) this.panelsContainer.style.height = `${currentHeight}px`;

        this.tabs.forEach((tab, tabIndex) => {
          const isSelected = tabIndex === index;
          tab.classList.toggle('is-active', isSelected);
          tab.setAttribute('aria-selected', isSelected.toString());
          tab.tabIndex = isSelected ? 0 : -1;
        });

        this.panels.forEach((panel, panelIndex) => {
          const isSelected = panelIndex === index;
          panel.classList.toggle('is-active', isSelected);
          panel.hidden = !isSelected;
        });

        this.activePanel = selectedPanel;
        requestAnimationFrame(() => this.syncPanelHeight());

        if (moveFocus) selectedTab.focus();
        // Horizontal-only: scrollIntoView() here also scrolled the page.
        const strip = selectedTab.closest('.filazoo-product-tabs__nav-wrap');
        if (strip) {
          const max = strip.scrollWidth - strip.clientWidth;
          if (max > 0) {
            const stripBox = strip.getBoundingClientRect();
            const tabBox = selectedTab.getBoundingClientRect();
            const delta = tabBox.left + tabBox.width / 2 - (stripBox.left + stripBox.width / 2);
            strip.scrollTo({ left: Math.min(Math.max(0, strip.scrollLeft + delta), max), behavior: 'smooth' });
          }
        }
        window.dispatchEvent(new Event('resize'));
      }

      syncPanelHeight(immediate = false) {
        if (!this.panelsContainer || !this.activePanel || this.activePanel.hidden) return;

        const targetHeight = this.activePanel.getBoundingClientRect().height;
        if (!targetHeight) return;

        if (immediate) this.panelsContainer.classList.remove('is-height-ready');
        this.panelsContainer.style.height = `${targetHeight}px`;

        if (immediate) {
          requestAnimationFrame(() => this.panelsContainer.classList.add('is-height-ready'));
        }
      }

      onKeydown(event, index) {
        let nextIndex;

        if (event.key === 'ArrowRight') nextIndex = (index + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.tabs.length - 1;

        if (nextIndex === undefined) return;
        event.preventDefault();
        this.selectTab(nextIndex, true);
      }
    }
  );
}
